export default __webpack_public_path__ + "static/media/worldAroundSofaPhoto.7e1c676e.jpg";